import React from 'react'
import { useIntl } from 'react-intl'
import { useParams } from 'react-router-dom'
import MainCommonView from '../../../../components/common/MainCommonView'
import useHandlerBasicActions from '../../../../utils/hooks/useHandlerBasicActions'
import { MadeService } from '../../../../services/purchase-fuel/made/made.service'
import MadePurchaseTable from '../../../../components/purchase-fuel/made/MadePurchaseTable'

const OwnFuelStationPurchasePrices = () => {
  const { formatMessage: msg } = useIntl()

  const { id } = useParams()

  const getPurchasesPricesByOwnStation = async ({
    filter,
    sort,
    limit,
    skip,
  }) => MadeService.getAllByOwnSttion({ id, filter, sort, limit, skip })

  const dataFacade = useHandlerBasicActions({
    sortFieldInitial: 'purchaseDate',
    sortInit: -1,
    getAll: getPurchasesPricesByOwnStation,
  })

  const headerOptions = {
    title: msg({ id: 'purchase.history' }),
    searchOptions: dataFacade?.searchOptions,
  }

  const pagerOptions = {
    ...dataFacade?.pagerOptions,
    totalRecords: dataFacade?.data?.total,
  }

  const dataTable = <MadePurchaseTable value={dataFacade?.data?.resp} />

  return (
    <MainCommonView
      headerOptions={headerOptions}
      componentData={dataTable}
      pagerOptions={pagerOptions}
    />
  )
}

export default OwnFuelStationPurchasePrices
